module.exports = __webpack_public_path__ + "media/flags/bs-6d51c666.svg";